import { ROLE_PERMISSION_PRESETS } from "../constants/role-permission-presets";
import { type DashboardRole, type RolePreviewState, isDashboardRole } from "../types/dashboard-role.types";

export function normalizeRolePreviewState(stored: unknown): RolePreviewState | null {
    if (!stored) {
        return null;
    }

    if (typeof stored === "string" && isDashboardRole(stored)) {
        return { permissions: [...ROLE_PERMISSION_PRESETS[stored]], teamIds: [], role: stored };
    }

    if (
        typeof stored === "object" &&
        stored !== null &&
        "permissions" in stored &&
        Array.isArray(stored.permissions) &&
        stored.permissions.every((permission) => typeof permission === "string")
    ) {
        const teamIds =
            "teamIds" in stored &&
            Array.isArray(stored.teamIds) &&
            stored.teamIds.every((teamId) => typeof teamId === "string")
                ? stored.teamIds
                : [];
        const role =
            "role" in stored && typeof stored.role === "string" && isDashboardRole(stored.role)
                ? stored.role
                : undefined;

        return { permissions: stored.permissions, teamIds, role };
    }

    return null;
}

export function togglePermissionInList(permissions: string[], permissionCode: string): string[] {
    if (permissions.includes(permissionCode)) {
        return permissions.filter((permission) => permission !== permissionCode);
    }

    return [...permissions, permissionCode];
}

export function toggleIdInList(ids: string[], id: string): string[] {
    if (ids.includes(id)) {
        return ids.filter((value) => value !== id);
    }

    return [...ids, id];
}

export function permissionsMatchPreset(permissions: string[], role: DashboardRole): boolean {
    const preset = ROLE_PERMISSION_PRESETS[role];
    if (permissions.length !== preset.length) {
        return false;
    }

    const permissionSet = new Set(permissions);
    return preset.every((permission) => permissionSet.has(permission));
}
